import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import CustomAlerts from "@src/@core/components/ui-components/alerts";
import { useEffect, useState } from "react";
import themeConfig from "@src/configs/theme-config";

dayjs.extend(utc);
const MAINTENANCE_WINDOW = {
    start: dayjs.utc(),
    end  : dayjs.utc("2025-07-30T19:00:00Z")  //31 July 12:30 AM IST
};

const MaintenanceBanner = () => {
    const [hide, setHide] = useState(true);

    useEffect(() => {
        const checkMaintenanceWindow = () => {
            const nowUTC = dayjs.utc();
            const inWindow = nowUTC.isAfter(MAINTENANCE_WINDOW.start) && nowUTC.isBefore(MAINTENANCE_WINDOW.end);

            setHide(!inWindow);
        };

        checkMaintenanceWindow();
        const interval = setInterval(checkMaintenanceWindow, 10000);

        return () => clearInterval(interval);
    }, []);

    return (
        <CustomAlerts
            color="danger"
            body={`${themeConfig.app.name} panel will be unavailable to use for 30 minutes from 30 July 23:59PM IST to 31 July 00:30 AM IST due to maintenance mode.`}
            controlled
            testId="maintenance-banner"
            className="mb-1"
            hide={hide}/>
    );
};

export default MaintenanceBanner;
